import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import './AdminCategories.css';

const AdminCategoriesManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isTagsActive = location.pathname.includes('/tags');

  return (
    <div className="admin-categories-management">
      <div className="admin-categories-management__header">
        <h1 className="admin-categories-management__title">Управление категориями/тегами</h1>
        <div className="admin-categories-management__tabs">
          <button 
            className={`admin-categories-management__tab ${!isTagsActive ? 'active' : ''}`}
            onClick={() => navigate('/admin/categories/list')}
          >
            Категории
          </button>
          <button 
            className={`admin-categories-management__tab ${isTagsActive ? 'active' : ''}`}
            onClick={() => navigate('/admin/tags/list')}
          >
            Теги
          </button>
        </div>
      </div>
      <div className="admin-categories-management__content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminCategoriesManagement;